<template>
    <Popup :show="show" v-on:closeEvent="close">
        <div class="popup-container">
            <div class="circle">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858Z" fill="white"/>
                </svg>
            </div>
            <h2>{{$t("lesson.LBL_TRIAL_POPUP_NOVISIT_HEADER")}}</h2>
            <span class="text" v-html="$t('lesson.LBL_TRIAL_POPUP_NOVISIT_CONTENT')"></span>
            <div class="buttons">
                <button class="button" @click="ok">
                <span>{{$t("lesson.LBL_TRIAL_POPUP_NOVISIT_BUTTON")}}</span>
                </button>
            </div>
        </div>
    </Popup>
</template>

<script>

    import Popup from '../../../../../components/Popup';

    export default {
        name: "TehBookingNoVisitPopup",
        components: {
            Popup
        },
        props: {
            show: {
                type: Boolean,
                required: true
            },
        },
        methods: {
            close(){
                this.$emit('closeEvent', null);
            },
            ok() {
                this.$emit('closeEvent', null);
            }
        }
    }
</script>

<style scoped lang="scss">
    .circle {
        width: 4.8rem;
        height: 4.8rem;
        background-color: #CF0920;
        border-radius: 10rem;
        margin-bottom: 1.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .popup-container {
        width: 100%;
        align-self: auto;
        display: flex;
        flex-direction: column;
    }
    h2 {
        padding-bottom: 0.8rem;
    }
    .text {
        font-family: FuturaPT;
        font-size: 1.6rem;
        line-height: 2rem;
        letter-spacing: 0.1rem;
        color: rgba(11, 16, 34, 0.3);
    }
    .buttons {
        width: 100%;
        display: flex;
        margin-top: auto;
        .button {
        margin-left: auto;
        padding: 0.75rem 2.5rem 1rem 2.5rem;
        }
    }
</style>
